import { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import Pagination from "../../Components/Pagination";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function ListISEEUploaded(props) {
  const apiToken = useContext(TokenContext);
  const [ISEEList, setISEEList] = useState();
  const [ISEEListTemp, setISEEListTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [isOpen, toggleModal] = useState(false);
  const [ISEEId, setISEEId] = useState();

  useEffect(() => {
    setLoading(false);
    Repo.getIseeListUploaded(apiToken)
      .then((response) => {
        setISEEListTemp(response.data);
        setLoading(true);
      })
      .catch((error) => {
        console.log(error);
        setLoading(true);
      });
  }, []);

  const deleteIsee = async () => {
    Repo.deleteIsee(apiToken, ISEEId)
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div>
      <h1>Lista ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Tutti gli ISEE caricati dagli utenti e non ancora validati</p>
          </div>
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col">Dati cittadino</th>
              <th scope="col">Codice Fiscale</th>
              <th scope="col">Data caricamento</th>
              <th scope="col">Valore ISEE caricato</th>
              <th scope="col">Anno</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {ISEEList && ISEEList.length > 0 ? (
              <>
                {ISEEList &&
                  ISEEList.map((x, index) => (
                    <tr key={index} index={index}>
                      {/* <th scope="row">{x.name}</th> */}
                      <th scope="row">
                        {x.user.firstName} {x.user.lastName}
                      </th>
                      <td>{x.user.fiscalCode}</td>
                      <td>{x.date}</td>
                      <td>
                        {x.value && parseFloat(x.value).toLocaleString("it-IT")}{" "}
                        €
                      </td>
                      <td>
                        {x.year}
                      </td>
                      <td>
                        <Link to={"/lista_isee/verifica_isee?idIsee=" + x.id}>
                          <button
                            className="btn btn-outline-primary p-2"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Modifica"
                          >
                            Dettaglio
                          </button>
                        </Link>
                      </td>
                    </tr>
                  ))}
              </>
            ) : (
              <>
                <tr>
                  <td colSpan="5">
                    <p className="text-center m-0">
                      <b>Non ci sono ISEE da verificare.</b>
                    </p>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </table>
        {ISEEListTemp && (
          <Pagination
            items={ISEEListTemp}
            setCurrentItems={setISEEList}
            itemsPerPage={5}
          ></Pagination>
        )}
      </div>

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Caricamento ISEE"
        body="Confermi di voler caricare l'ISEE?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteIsee()}
      ></ModalComponent>
      {!loading && <Loader></Loader>}
    </>
  );
}

export default ListISEEUploaded;
